<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>EXAMENES DE LABORATORIO</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{'tokenAtencion ' + tokenAtencion }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="examenes"
                :comentarios="comentarios"
              />
            </div>


            <ExamenesList
              onlyView
              v-if="examenes && examenes.length"
              v-model="examenes"
            />

            <RegistroEnvioLabsAux
              :tokenAtencion="tokenAtencion"
              :title="`Envio de laboratorios`"
              onlyView
            />

            <!-- <EmptyResults
              v-if="showEmptyResults"
              :message="'No se encontraron examenes para mostrar.'"
            /> -->
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { EmptyResults } from '@/shared/components';
import { ExamenesList, RegistroEnvioLabsAux } from '@/views/laboratorio/components';
import { estudioLabService } from '@/views/laboratorio/services';

import CommentEditor from '../CommentEditor/CommentEditor.vue';

export default {
  name: "AtencionExamenes",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },
  },

  components: {
    EmptyResults,
    ExamenesList,
    RegistroEnvioLabsAux,
    CommentEditor
  },

  data() {
    return {
      visibleBody: false,
      examenes: null,
      examenesAuxiliares: null,

      comentarios:{},
    };
  },

  created() {
    this.onGetData();
  },

  methods: {
    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },

    async onGetData() {
      const data = await estudioLabService.getByAtencion(this.tokenAtencion);
      if (!data) return;

      this.examenes = data?.labAs400;
      
      // cargar los auxiliares 
      
      this.examenesAuxiliares = data?.labAuxiliares;
    }
  },


  computed:{
    showEmptyResults() {
      return (!this.examenes || this.examenes.length === 0 ) && (!this.examenesAuxiliares || this.examenesAuxiliares.length === 0)
    }
  },

  watch: {

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.examenes
        this.$store.commit("setComentarios", { examenes: comentario });
      }
    }
  }
}
</script>
